import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../../api/api';
import {PIdNameModel} from '../../projects/types';
import {REmployees} from '../types';


const initialState: PIdNameModel[] = []

export const getRoles = createAsyncThunk(
    'roles/all',
    async () => {
        const response = await HttpClient.roleApi.getAllRoles<PIdNameModel[]>();
        return response.data
    }
)

export const filterRoles = createAsyncThunk(
    'roles/filter',
    async (filter: string) => {
        const response = await HttpClient.roleApi.filterRoles<PIdNameModel[]>(filter);
        return response.data;
    }
)

const typeSplice = createSlice({
    name: 'eRoles',
    initialState,
    reducers: {
        clear: (state) => {
            return initialState
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRoles.fulfilled, (state, action) => {
            return [...action.payload];
        })
    }
})

export const { clear } = typeSplice.actions

export default typeSplice.reducer;
